<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard no-header>
        <CCardBody>
            <div class="row">
              <div class="col-4">
                <CInput readonly :label="$t('fields.name')" type="text" v-model="client.name"></CInput>
              </div>
              <div class="col-4">
                <CInput readonly :label="$t('fields.address')" type="text" v-model="client.address"></CInput>
              </div>
              <div class="col-4">
                <CInput readonly :label="$t('fields.address2')" type="text" v-model="client.address2"></CInput>
              </div>
            </div>
            
            <div class="row">
              <div class="col-4">
                <CInput readonly :label="$t('fields.phone')" type="text" v-model="client.phone"></CInput>
              </div>
              <div class="col-4">
                <CInput readonly :label="$t('fields.phone2')" type="text"  v-model="client.phone2"></CInput>
              </div>
              <div class="col-4">
                <CInput readonly :label="$t('fields.state')" type="text" v-model="client.state"></CInput>
              </div>
            </div>
            
            <div class="row">
              <div class="col-4">
                <CInput readonly :label="$t('fields.city')" type="text" v-model="client.city"></CInput>
              </div>
              <div class="col-4">
                <CInput readonly :label="$t('fields.zipcode')" type="text" v-model="client.zipcode"></CInput>
              </div>
              <div class="col-4">
                <CInput readonly :label="$t('fields.order_date')" type="date" v-model="order.order_date"></CInput>
              </div>
            </div>

            <div class="row">
              <div class="col-4">
                 <CInput readonly :label="$t('fields.payment_type')" type="text" v-model="order.payment_type"></CInput>
              </div>
              <div class="col-4">
                <CInput readonly :label="$t('fields.driver')" type="text" v-model="order.driver"></CInput>
              </div>
              <div class="col-4">
                <CTextarea readonly :label="$t('fields.comment')" v-model="order.comment"></CTextarea>
              </div>
            </div>

            <div class="row">
              <div class="col-6">
                <CDataTable
                  class="mb-0 table-outline"
                  :items="order.delivery_types"
                  :fields="fields"
                  head-color="light"
                  hover
                  no-sorting
                  >
                  <td slot="price" slot-scope="{item}">
                    ${{ item.price | toCurrency }}
                  </td>
                </CDataTable>
              </div>
            </div>

            <div class="row mt-5">
              <div class="col-6">
                <label>{{ $t('fields.document') }} </label>
                <div class="d-flex flex-row align-items-end" v-if="imageUrl !== ''">
                  <div class="p-2">
                    <img :src="imageUrl">
                  </div>
                  <div class="p-2">
                    <CButton color="primary" @click="deleteImage()">
                      <CIcon :content="$options.deleteIcon" />
                    </CButton>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h5>{{ $t('fields.attended_by') }}: {{ userName }}</h5>
              </div>
            </div>
            
            <div class="row pt-4">
              <div class="col-4">
                <CButton v-if="permissions.orders.edit" color="success" @click="editOrder">
                  <CIcon :content="$options.editIcon" /> {{ $t('button.edit') }}</CButton>
                <CButton color="primary" @click="goBack">
                  <CIcon :content="$options.backIcon" /> {{ $t('button.back') }}
                </CButton>
              </div>
            </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue';
import { mapState } from 'vuex';
import axios from 'axios';
import formMixin from '../../mixins/form';
import localeMixin from '../../mixins/locale'; // Order matters, mixin first then i18n.
import i18n from "../../i18n";
import { cilPencil, cilArrowLeft, cilBan } from '@coreui/icons';

Vue.filter('toCurrency', function (value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
});

export default {
  name: 'Order',
  mixins: [formMixin, localeMixin],
  editIcon: cilPencil,
  backIcon: cilArrowLeft,
  deleteIcon: cilBan,
  data() {
    return {
        client: {
          name: '',
          address: '',
          address2: '',
          phone: '',
          phone2: '',
          state: '',
          city: '',
          zipcode: '',
        },
        order: {
          product: '',
          quantity: '',
          total: 0,
          payment_type: '',
          deliveryTypes: [],
          driver: '',
          document: '',
          order_date: '',
          comment: ''
        },
        imageUrl: '',
        products: [],
        productSelect: [],
        paymentTypes: [],
        paymentSelect: [],
        driverSelect: [],
        phoneNumber: '',
        userName: '',
        fields: [
          { key: 'name', label: i18n.t('fields.delivery_type') },
          { key: 'quantity', label: i18n.t('fields.bottles_quantity') },
          { key: 'price', label: i18n.t('fields.price') }
        ]
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions,
    })
  },
  mounted() {
    this.getOrder();
  },
  methods: {
    goBack() {
        this.$router.push({ name: "Orders" });
    },
    editOrder() {
      const id = this.$route.params.id;
      this.$router.push({ name: "EditOrder", params: {id} });
    },
    getOrder() {
      const id = this.$route.params.id;
      axios.get('/api/orders/' + id + '?token=' + localStorage.getItem("api_token"))
      .then(response => {
        const data = response.data;
        if (data) {
            
          this.order.driver = data.driver;
          this.order.product = data.product;
          this.order.payment_type = data.payment_type;
          this.order.quantity = data.quantity;
          this.order.comment = data.comment;
          this.order.order_date = data.order_date;
          console.log(this.order.order_date);
          this.order.delivery_types = data.delivery_types;
          this.order.document = data.document;
          this.imageUrl = data.documentUrl;
          
          // client info
          this.client.name = data.name;
          this.client.address = data.address;
          this.client.address2 = data.address2;
          this.client.city = data.city;
          this.client.state = data.state;
          this.client.zipcode = data.zipcode;
          this.client.phone = data.phone;
          this.client.phone2 = data.phone2;
          this.userName = data.user;
        }
      }).catch(error => {
        console.log(error);
        this.$router.push({ path: '/login' });
      });
    }
  }
}

</script>

<style scoped>
.card-body img {
  width: 200px;
  height: 200px
}
</style>
